import { AxiosResponse } from 'axios';
import HttpClient from '../utils/HttpClientHandler';
import { Client, ClientCredentials, NewClient, NewClientCredentials } from '../types/Client';

const ClientService = class ClientService {
    #baseURL: string;

    constructor() {
        this.#baseURL = '/dashboard/client';
    }

    public async getAllClients(
        offset?: number,
        limit?: number,
        filters?: { [key: string]: any },
    ): Promise<{ count: number; list: Client[] }> {
        const offSetParam = offset && offset > 0 ? offset : undefined;
        const limitParam = limit && limit >= -1 ? limit : undefined;
        const response: AxiosResponse = await HttpClient.get(this.#baseURL, {
            params: {
                ...(offSetParam ? { offset: offSetParam } : {}),
                ...(limitParam ? { limit: limitParam } : {}),
                ...(filters || {}),
            },
        });
        const { data }: { data: { count: number; list: Client[] } } = response;
        return data;
    }

    public async countAllClients(): Promise<{ count: number }> {
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}/count`);
        const { data }: { data: { count: number } } = response;
        return data;
    }

    public async getClientById(clientId: number): Promise<Client> {
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}/${clientId}`);
        const { data }: { data: Client } = response;
        return data;
    }

    public async getClientCredentialsByClientId(clientId: number): Promise<ClientCredentials> {
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}/${clientId}/credentials`);
        const { data }: { data: ClientCredentials } = response;
        return data;
    }

    public async createClient(newClientData: NewClient): Promise<Client> {
        const response: AxiosResponse = await HttpClient.post(this.#baseURL, newClientData);
        const { data }: { data: Client } = response;
        return data;
    }

    public async updateClientById(clientId: number, clientData: NewClient): Promise<Client> {
        const response: AxiosResponse = await HttpClient.patch(`${this.#baseURL}/${clientId}`, clientData);
        const { data }: { data: Client } = response;
        return data;
    }

    public async upsertCredentials(clientId: number, credentials: NewClientCredentials): Promise<boolean> {
        const response: AxiosResponse = await HttpClient.post(`${this.#baseURL}/${clientId}/credentials`, credentials);
        return response.status === 200;
    }

    public async deleteClientById(clientId: number): Promise<void> {
        await HttpClient.delete(`${this.#baseURL}/${clientId}`);
    }
};

export default new ClientService();
